import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CalendarGroupService } from '../../../services/calendar-group/calendar-group.service';
import { CalendarGroup } from '../../../models/calendar-group.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-calendar-group',
  templateUrl: './calendar-group.component.html',
  styleUrls: ['./calendar-group.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: []
})
export class CalendarGroupComponent implements OnInit {

  public calendarGroups: CalendarGroup[] = [];
  public newDataAvailable = false;

  constructor (
    private router: Router,
    public srvCalendarGroup: CalendarGroupService
  ) { }

  ngOnInit() {
    this.srvCalendarGroup.getAll().subscribe(groups => {
      this.calendarGroups = groups
    });
  }

  showAddOrEditDialog(data: CalendarGroup): void {
    console.log(data);

    this.srvCalendarGroup.calendarGroupEditing = data == null ? new CalendarGroup() : data;

    if (data !== null) {
      console.log('edit group');
      this.router.navigate(['/calendargroups/form/', data.id]);
    } else {
      console.log('add group');
      this.router.navigate(['/calendargroups/form/', '']);
    }
  }

  delete (record): void {
    this.srvCalendarGroup.delete(record).subscribe(() => {
      this.newDataAvailable = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar-group/calendar-group.component.ts